import { useNavigate } from 'react-router-dom';
import { useTheme } from '../theme/ThemeContext';


const NotFound = () => {
    const theme = useTheme();
    const navigate = useNavigate();

    return (
        <div style={{
            minHeight: '100vh',
            background: theme.bg,
            display: 'flex', flexDirection: 'column',
            alignItems: 'center', justifyContent: 'center',
            fontFamily: theme.sans, color: theme.text,
            gap: 0,
        }}>
            {/* Glow */}
            <div style={{
                position: 'fixed', top: '20%', left: '50%', transform: 'translateX(-50%)',
                width: 400, height: 400, borderRadius: '50%',
                background: 'radial-gradient(circle, rgba(59,130,246,0.07) 0%, transparent 70%)',
                pointerEvents: 'none',
            }} />

            <div style={{
                fontSize: 100, fontWeight: 900,
                background: 'linear-gradient(135deg, #3b82f6, #6366f1)',
                WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
                lineHeight: 1, letterSpacing: '-4px',
            }}>
                404
            </div>

            <div style={{ fontSize: 20, fontWeight: 700, marginTop: 16, color: theme.text }}>
                Page Not Found
            </div>

            <div style={{ fontSize: 13, color: '#64748b', marginTop: 8, textAlign: 'center', maxWidth: 280 }}>
                The page you're looking for doesn't exist or has been moved.
            </div>

            <button
                onClick={() => navigate('/dashboard')}
                style={{
                    marginTop: 32, padding: '11px 28px', borderRadius: 10, border: 'none',
                    background: 'linear-gradient(135deg, #2563eb, #4f46e5)',
                    color: '#fff', fontSize: 13, fontWeight: 700,
                    cursor: 'pointer', fontFamily: theme.sans,
                    boxShadow: '0 4px 20px rgba(59,130,246,0.35)',
                    transition: 'opacity 0.2s',
                }}
                onMouseEnter={e => e.currentTarget.style.opacity = '0.85'}
                onMouseLeave={e => e.currentTarget.style.opacity = '1'}
            >
                ← Back to Dashboard
            </button>
        </div>
    );
};

export default NotFound;